export default {
  props: {
    /**
      * URL to navigate to when interacting with component
      */
    url: {type: String, default: '#'}
  }
};
